import { Link, PlusCircleIcon, PencilSquareIcon, useMemo } from "@";

const LinkBtn = ({ to, className, create, edit }) => {
  const buttonContent = useMemo(() => {
    if (create) {
      return (
        <>
          <PlusCircleIcon className="h-5 w-5 transition-transform group-hover:rotate-90" />
          <span className="inline">إضافة</span>
        </>
      );
    }
    if (edit) {
      return (
        <>
          <PencilSquareIcon className="h-5 w-5 transition-transform group-hover:-rotate-12" />
          <span className="inline">تعديل</span>
        </>
      );
    }
    return null;
  }, [create, edit]);

  return (
    <Link
      to={to}
      className={`group rounded-full gap-1.5 transition-all duration-200 hover:-translate-y-px ${
        className ||
        "btn-green hover:shadow-sm hover:shadow-emerald-700/30 disabled:hover:shadow-none"
      }`}
    >
      {buttonContent}
    </Link>
  );
};

export default LinkBtn;
